import {
  fetchAccountDetails,
  fetchTransactionDetails,
  getAmexDisputeStages,
  getCaseStageLandingData,
  postLockCase,
  unlockAllCases,
  unlockCase,
  fetchTakeActionStatusOnMerchantUiSLAExpire,
} from '../api/caseDataAPI';
import {
  fetchAuthDetails,
  getActionPages,
  getBankDetails,
  getCaseLandingData,
  getCaseLandingData2,
  getMerchantDetails,
  getTakeActions,
} from '../api/caseManagerAPI';
import { getCaseEventLog, getCaseHistory } from '../api/eventManagerApi';
import { formatResponseStageCards, getCardBrandCode } from 'Utils/functionalUtils';
import {
  AMEX_DISPUTE_STAGES,
  CASE_DATA,
  CASE_DATA_FAILURE,
  CASE_REVISIT,
  RESET_CASE_REVISIT,
  RESET_CASE_UPDATE,
  UNLOAD_ALL_CASES,
  UNLOAD_CASE_AS_ACTIVE,
  UNLOAD_CASE_ERROR,
  UNLOAD_CASE_INFO,
} from './actionTypes';

export const fetchOp1Case = (caseStageId) => async (dispatch) => {
  const op1CaseData = await getCaseStageLandingData(caseStageId);
  let completeCaseInfo = {
    ...op1CaseData,
    data: {
      ...op1CaseData.data,
      isOp1orWex: true,
    },
  };
  dispatch({
    type: CASE_DATA,
    caseInfo: completeCaseInfo.data,
  });
};

export const fetchAmexDisputeStages = () => async (dispatch) => {
  const amexDisputeStages = await getAmexDisputeStages();
  dispatch({
    type: AMEX_DISPUTE_STAGES,
    disputeStages: amexDisputeStages.data,
  });
};

async function fetchMerchantDetails(caseNumber, disputeStageId) {
  let merchantData;
  try {
    merchantData = await getMerchantDetails(caseNumber, disputeStageId);
  } catch (e) {
    merchantData = { data: null };
  }
  return merchantData;
}

async function getAccountDetails(caseNumber) {
  let accountDetails;
  try {
    accountDetails = await fetchAccountDetails(caseNumber);
  } catch (e) {
    accountDetails = { data: null };
  }
  return accountDetails;
}

async function getAuthDetails(caseNumber) {
  let authDetails;
  try {
    authDetails = await fetchAuthDetails(caseNumber);
  } catch (e) {
    authDetails = { data: null };
  }
  return authDetails;
}

async function getTransactionDetails(caseNumber) {
  let transactionDetails;
  try {
    transactionDetails = await fetchTransactionDetails(caseNumber);
  } catch (e) {
    transactionDetails = { data: null };
  }
  return transactionDetails;
}

async function fetchBankDetails(cardBrandCode, caseDetailIssuerBinIca, disputeStageId) {
  let bankDetails;
  try {
    bankDetails =
      cardBrandCode && caseDetailIssuerBinIca
        ? await getBankDetails(cardBrandCode, caseDetailIssuerBinIca, disputeStageId)
        : { data: null };
  } catch (e) {
    bankDetails = { data: null };
  }
  return bankDetails;
}

async function fetchActionPages(caseNumber, cardBrandCode, disputeStageId) {
  let actionPages;
  try {
    actionPages = await getActionPages(caseNumber, cardBrandCode, disputeStageId);
  } catch (e) {
    actionPages = { data: null };
  }
  return actionPages;
}

async function fetchTakeActions(disputeStageId, cardBrandCode, statusId, caseNumber) {
  let takeActionsData;
  try {
    takeActionsData = await getTakeActions(disputeStageId, cardBrandCode, statusId, caseNumber);
  } catch (e) {
    takeActionsData = { data: null };
  }
  return takeActionsData;
}

async function fetchCaseEventLog(caseNumber) {
  let caseEventLog;
  try {
    caseEventLog = await getCaseEventLog(caseNumber);
  } catch (e) {
    caseEventLog = { data: null };
  }
  return caseEventLog;
}

async function fetchCaseHistory(caseNumber) {
  let caseHistory;
  try {
    const response = await getCaseHistory(caseNumber);
    caseHistory = formatResponseStageCards(response.data);
  } catch (error) {
    caseHistory = null;
  }
  return caseHistory;
}

async function fetchLockCase(caseNumber, caseStageId) {
  let lockCase;
  try {
    lockCase = await postLockCase(caseNumber, caseStageId);
  } catch (e) {
    lockCase = { data: null, status: e };
  }
  return lockCase;
}

async function fetchMerchantUiSLAExpireStatus(caseNumber) {
  let isMerchantUiSLAExpired;
  try {
    isMerchantUiSLAExpired = await fetchTakeActionStatusOnMerchantUiSLAExpire(caseNumber);
  } catch (e) {
    isMerchantUiSLAExpired = { data: null };
  }
  return isMerchantUiSLAExpired;
}

const getCaseStageDetail = (caseData) => {
  if (caseData.activeCaseStageDetail) {
    return caseData.activeCaseStageDetail;
  } else if (caseData.caseStageDetail) {
    return caseData.caseStageDetail;
  } else {
    return undefined;
  }
};

export const fetchCase = (caseNumber, isView) => async (dispatch) => {
  const acquirerNames = ['MXP', 'EMD'];
  let caseData;
  try {
    caseData = isView ? await getCaseLandingData2(caseNumber, isView) : await getCaseLandingData(caseNumber);
  } catch (e) {
    caseData = null;
  }
  if (caseData) {
    const disputeStageId = caseData.data.caseStageDetail.disputeStageId
      ? caseData.data.caseStageDetail.disputeStageId
      : undefined;

    const caseStageDetail = getCaseStageDetail(caseData.data);
    
    let cardBrandCodeforBankDetails =
      caseData.data.caseDetail.cardBrandCode && caseData.data.caseDetail.acquirerName && 
      (caseData.data.caseDetail.cardBrandCode === 'VI' || caseData.data.caseDetail.cardBrandCode === 'MC' || acquirerNames.includes(caseData.data.caseDetail.acquirerName))
        ? caseData.data.caseDetail.cardBrandCode
        : undefined;
        
    const caseDetailIssuerBinIca = caseData.data.caseDetail.issuerBinIca
      ? caseData.data.caseDetail.issuerBinIca
      : undefined;
    const acquirerAccessCode = caseData.data.caseDetail.acquirerName
      ? caseData.data.caseDetail.acquirerName
      : undefined;

    let cardBrandCode = getCardBrandCode(acquirerAccessCode, caseData.data.caseDetail.cardBrandCode);
    const role = JSON.parse(sessionStorage.getItem('state')).auth.user.role.key;
    const internalEmployees = [
      'DiMS_INTERNAL_EMPLOYEE',
      'DiMS_DISPUTE_SUPPORT',
      'DiMS_PRODUCTION_SUPPORT',
      'DiMS_SETTLEMENT_ANALYST',
    ];
    let isInternalUser = false;
    if (internalEmployees.findIndex((internalEmp) => internalEmp === role) !== -1) {
      isInternalUser = true;
    }

    await Promise.allSettled([
      fetchMerchantDetails(caseNumber, disputeStageId),
      getAccountDetails(caseNumber),
      getAuthDetails(caseNumber),
      getTransactionDetails(caseNumber),
      fetchBankDetails(acquirerAccessCode === 'MXP' ? 'PR': acquirerAccessCode === 'EMD' ? 'EV' : cardBrandCodeforBankDetails, caseDetailIssuerBinIca, disputeStageId),//TODO: need to replace condition with cardbrandcode object after evo looker changes
      fetchActionPages(caseNumber, cardBrandCode, caseStageDetail?.disputeStageId),
      fetchTakeActions(caseStageDetail?.disputeStageId, cardBrandCode, caseStageDetail?.statusId, caseNumber),
      fetchCaseEventLog(caseNumber),
      fetchCaseHistory(caseNumber),
      fetchMerchantUiSLAExpireStatus(caseNumber),
    ]).then((responses) => {
      let completeCaseInfo = {
        ...caseData,
        data: {
          ...caseData.data,
          merchantDetail: responses[0].value ? responses[0]?.value?.data : { data: null },
          accountDetail: responses[1]?.value?.data,
          authorizationDetail: responses[2]?.value?.data,
          transactionDetail: responses[3]?.value?.data,
          bankDetail: responses[4]?.value?.data,
          takeActionPageDetail: responses[5]?.value?.data,
          takeActions: responses[6]?.value?.data,
          historyData: responses[7]?.value?.data,
          caseHistory: responses[8]?.value,
          caseUpdated: isView,
          isOp1OrWex: false,
          isMerchantUiSLAExpired: responses[9]?.value?.data,
          isCaseRevisited: false,
        },
      };
     if (!isInternalUser && disputeStageId !== 28) {
        fetchLockCase(caseNumber, caseData.data.caseStageDetail.caseStageId).then((response) => {
          completeCaseInfo = {
            ...completeCaseInfo,
            data: {
              ...completeCaseInfo.data,
              lockCaseInfo: response,
              activeCase: response.data && !response.data.isCaseLocked ? true : false,
            },
          };
          dispatch({
            type: CASE_DATA,
            caseInfo: completeCaseInfo.data,
          });
        });
      } else {
        completeCaseInfo = {
          ...completeCaseInfo,
          data: {
            ...completeCaseInfo.data,
            lockCaseInfo: { data: null },
            activeCase: false,
          },
        };
        dispatch({
          type: CASE_DATA,
          caseInfo: completeCaseInfo.data,
        });
      }
    });
  } else {
    dispatch({
      type: CASE_DATA_FAILURE,
      caseNumber,
    });
  }
};

export const unloadCaseAsActive = (caseNumber, caseStageId) => async (dispatch) => {
  try {
    await unlockCase(caseNumber, caseStageId);
    dispatch({
      type: UNLOAD_CASE_AS_ACTIVE,
      caseNumber,
    });
  } catch {
    dispatch({
      type: UNLOAD_CASE_ERROR,
    });
  }
};

export const unloadAllCases = (caseNumbers) => async (dispatch) => {
  try {
    await unlockAllCases(caseNumbers);
    dispatch({
      type: UNLOAD_ALL_CASES,
    });
  } catch {
    dispatch({
      type: UNLOAD_CASE_ERROR,
    });
  }
};

export const unloadCaseInfo = (caseNumber) => async (dispatch) => {
  dispatch({
    type: UNLOAD_CASE_INFO,
    caseNumber,
  });
};

export const resetCaseUpdateFlag = (caseNumber) => async (dispatch) => {
  dispatch({
    type: RESET_CASE_UPDATE,
    caseNumber,
  });
};

export const revisitCase = (caseNumber) => async (dispatch) => {
  dispatch({
    type: CASE_REVISIT,
    caseNumber,
  });
};

export const resetCaseRevisitFlag = (caseNumber) => async (dispatch) => {
  dispatch({
    type: RESET_CASE_REVISIT,
    caseNumber,
  });
};
